export default __webpack_public_path__ + "static/media/Fall_13.4e162f71.png";